import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule, TooltipPosition } from '@angular/material/tooltip';
import { DirectivesModule } from '@shared/directives/directives.module';

/**
 * Renders an <a> to an absolute external URL (e.g. Data Stack), or a disabled,
 * non-clickable version of the same icon when the target record doesn't exist there.
 *
 * Deliberately lean: unlike GoesToRecordComponent, it has no internal-routerLink,
 * linkGenerator, or navigation-source concerns - just an external href + disabled state.
 */
@Component({
  selector: 'miq-goes-to-external-record',
  templateUrl: 'goes-to-external-record.component.html',
  styleUrls: ['goes-to-external-record.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatIconModule, MatTooltipModule, DirectivesModule],
})
export class GoesToExternalRecordComponent {
  @Input() public href: string | null = null;
  @Input() public disabled = false;
  @Input() public classes: string;
  @Input() public svgIconName = 'open_in_browser';
  @Input() public targetAnchor = null;
  @Input() public toolTipMessage: string;
  @Input() public toolTipPosition: TooltipPosition = 'below';
}
